var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#calendar_svg__a)",
    fillRule: "evenodd",
    d: "M19.75 2.25H.25v15.5h19.5zm-18 4v-2.5h2.5v2.5zm0 1.5v8.5h16.5v-8.5zm16.5-1.5v-2.5h-2.5v2.5zm-4-2.5h-8.5v2.5h8.5z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar_svg__a",
    x1: 17,
    x2: 0.5,
    y1: 2.5,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.126,
    stopColor: "#FF7880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#15CFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3BF2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#6675FF"
  })))));
};
export { SvgCalendar as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTkuNzUgMi4yNUgwLjI1VjE3Ljc1SDE5Ljc1VjIuMjVaTTEuNzUgNi4yNVYzLjc1SDQuMjVWNi4yNUgxLjc1Wk0xLjc1IDcuNzVWMTYuMjVIMTguMjVWNy43NUgxLjc1Wk0xOC4yNSA2LjI1VjMuNzVIMTUuNzVWNi4yNUgxOC4yNVpNMTQuMjUgMy43NUg1Ljc1VjYuMjVIMTQuMjVWMy43NVoiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8zNDU4XzYxNTU2KSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzM0NThfNjE1NTYiIHgxPSIxNyIgeTE9IjIuNSIgeDI9IjAuNDk5OTk5IiB5Mj0iMTgiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agb2Zmc2V0PSIwLjEyNjMwMiIgc3RvcC1jb2xvcj0iI0ZGNzg4MCIvPgo8c3RvcCBvZmZzZXQ9IjAuMzc0NCIgc3RvcC1jb2xvcj0iIzE1Q0ZFNCIvPgo8c3RvcCBvZmZzZXQ9IjAuNjI1MTU0IiBzdG9wLWNvbG9yPSIjM0JGMkE1Ii8+CjxzdG9wIG9mZnNldD0iMC44NzYzNDgiIHN0b3AtY29sb3I9IiM2Njc1RkYiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";